module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"IM90S Dashboard","short_name":"IM90S","start_url":"/app/home","background_color":"#0F4C5C","theme_color":"#0F4C5C","display":"minimal-ui","icon":"src/components/images/logos/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"30ce7043799cf001de01bd159eba6914"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
